/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Warm_Falcon_BoltInputs */

const en_vivid_warm_falcon_bolt = /** @type {(inputs: Vivid_Warm_Falcon_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import of users`)
};

const de_vivid_warm_falcon_bolt = /** @type {(inputs: Vivid_Warm_Falcon_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import von Benutzern`)
};

/**
* | output |
* | --- |
* | "Import of users" |
*
* @param {Vivid_Warm_Falcon_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_warm_falcon_bolt = /** @type {((inputs?: Vivid_Warm_Falcon_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Warm_Falcon_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_warm_falcon_bolt(inputs)
	return de_vivid_warm_falcon_bolt(inputs)
});